// extracted by mini-css-extract-plugin
export default {"iconLink":"src-hello-react-components-icon-link-icon-link__iconLink--29yuV","icon":"src-hello-react-components-icon-link-icon-link__icon--2ZK6L"};